(() => {
  if (window.__engravingRuntimeLoaded) return;
  window.__engravingRuntimeLoaded = true;
  const CUSTOM_KIT_PROPERTY_KEY = '_kit_variant_id';
  const CUSTOM_KIT_ADDON_KEY = '_kit_addon';
  const ADDON_VARIANTS = {
    kit: '51296731562315',
    gift: '51349981167947',
    empreinte1: '52926435852619',
    empreinte2: '56309706654027',
    texte: '52926435787083',
    ecrit: '56309688435019'
  };

  const ADDON_IDS = new Set([
    ADDON_VARIANTS.kit,
    ADDON_VARIANTS.empreinte1,
    ADDON_VARIANTS.empreinte2,
    ADDON_VARIANTS.texte,
    ADDON_VARIANTS.ecrit
  ]);
  const DISPLAY_HIDDEN_ADDON_IDS = new Set([
    ADDON_VARIANTS.empreinte1,
    ADDON_VARIANTS.empreinte2,
    ADDON_VARIANTS.texte,
    ADDON_VARIANTS.ecrit
  ]);
  const CART_REFRESH_EVENT = 'cart:refresh';

  const normalize = (value) => {
    if (!value) return '';
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2019\u2018]/g, "'")
      .toLowerCase()
      .trim();
  };


  const getCartUrl = () => (window.theme?.routes?.cart_url ? `${window.theme.routes.cart_url}.js` : '/cart.js');
  const getCartAddUrl = () => window.theme?.routes?.cart_add_url || '/cart/add.js';
  const getCartChangeUrl = () => window.theme?.routes?.cart_change_url || '/cart/change.js';

  const formatMoneySafe = (cents) => {
    if (typeof cents !== 'number') return '';
    if (typeof formatMoney === 'function') {
      const format = window.theme?.settings?.money_with_currency_format;
      return formatMoney(cents, format || undefined);
    }
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const parseMediaAltGroups = (altText) => {
    if (!altText) return { groups: [], showAll: false };
    const parts = String(altText)
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean);

    const groups = [];
    let showAll = false;

    parts.forEach((part) => {
      let normalized = part
        .toLowerCase()
        .replace(/m\u00e9tal/g, 'metal')
        .replace(/cha\u00eene/g, 'chaine')
        .replace(/metal\s*:/g, 'metal=')
        .replace(/chain\s*:/g, 'chain=')
        .replace(/chaine\s*:/g, 'chain=')
        .replace(/,/g, ';');

      if (normalized.includes('show=all')) {
        showAll = true;
      }

      const metalMatch = normalized.match(/metal\s*=\s*([^;]+)/);
      const chainMatch = normalized.match(/chain\s*=\s*([^;]+)/);
      const motifMatch = normalized.match(/gravure\s*=\s*([^;]+)/);
      if (!metalMatch) return;

      const metalHandle = normalize(metalMatch[1]).replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      if (!metalHandle) return;
      const motifHandle = motifMatch
        ? normalize(motifMatch[1]).replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
        : '';
      const motifGroup = motifHandle ? `__motif-de-gravure_${motifHandle}` : '';
      if (chainMatch) {
        const chainHandle = normalize(chainMatch[1]).replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
        if (!chainHandle) return;
        groups.push(`metal-precieux_${metalHandle}__style-de-chaine_${chainHandle}${motifGroup}`);
        return;
      }
      groups.push(`metal-precieux_${metalHandle}__style-de-chaine_any${motifGroup}`);
    });

    return { groups, showAll };
  };

  const applyMediaGroups = () => {
    const scripts = document.querySelectorAll('script[data-engraving-media]');
    scripts.forEach((script) => {
      let mediaList = [];
      try {
        mediaList = JSON.parse(script.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(mediaList)) return;

      const sectionId = script.dataset.sectionId || '';
      mediaList.forEach((media) => {
        const mediaId = media?.id;
        if (!mediaId) return;
        const selector = `[data-media-id="${sectionId}-${mediaId}"]`;
        const slide = document.querySelector(selector);
        const thumb = document.getElementById(`Thumb-${sectionId}-${mediaId}`);
        const { groups, showAll } = parseMediaAltGroups(media?.alt);
        if (!groups.length && !showAll) return;

        const groupValue = groups[0] || 'show-all';
        const groupsValue = groups.length ? groups.join('|') : 'show-all';
        [slide, thumb].forEach((element) => {
          if (!element) return;
          element.dataset.group = groupValue;
          element.dataset.groups = groupsValue;
          if (showAll) {
            element.dataset.showAll = 'true';
          }
        });
      });

      const variantSelects = document.querySelector(`variant-selects[data-custom-variant-picker][data-section="${sectionId}"]`);
      if (variantSelects) {
        variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const getVariantFromSection = (sectionId) => {
    if (!sectionId) return null;
    const form = document.getElementById(`product-form-${sectionId}`);
    const variantId = form?.querySelector('input[name="id"]')?.value;
    if (!variantId) return null;
    const picker =
      document.getElementById(`variant-selects-${sectionId}`) ||
      document.querySelector(`variant-selects[data-section="${sectionId}"]`) ||
      document.querySelector(`variant-radios[data-section="${sectionId}"]`);
    const dataEl = picker?.querySelector('[type="application/json"]');
    if (!dataEl) return null;
    try {
      const variants = JSON.parse(dataEl.textContent);
      return variants.find((item) => String(item.id) === String(variantId)) || null;
    } catch (error) {
      return null;
    }
  };

  const ensureAtcPriceElements = (sectionId) => {
    const buttons = Array.from(document.querySelectorAll('button.single-add-to-cart-button'));
    buttons.forEach((button) => {
      if (button.querySelector('[data-add-to-cart-price]')) return;

      const separator = document.createElement('span');
      separator.className = 'single-add-to-cart-button--separator';
      separator.setAttribute('data-add-to-cart-separator', '');
      if (sectionId) separator.setAttribute('data-section-id', sectionId);
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = ' | ';

      const price = document.createElement('span');
      price.className = 'single-add-to-cart-button--price';
      price.setAttribute('data-add-to-cart-price', '');
      if (sectionId) price.setAttribute('data-section-id', sectionId);

      const loadingOverlay = button.querySelector('.loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.before(separator);
        loadingOverlay.before(price);
      } else {
        button.appendChild(separator);
        button.appendChild(price);
      }
    });
  };

  const updatePriceBlocks = (sectionId, priceText, compareAtText, showCompareAt) => {
    const priceWraps = [
      document.getElementById(`price-${sectionId}`),
      document.getElementById(`price-${sectionId}--sticky`)
    ];

    priceWraps.forEach((wrap) => {
      if (!wrap || !priceText) return;
      const insAmount = wrap.querySelector('ins .amount');
      if (insAmount) {
        insAmount.textContent = priceText;
      }
      const del = wrap.querySelector('del');
      if (!del) return;
      if (showCompareAt && compareAtText) {
        del.style.display = '';
        const delAmount = del.querySelector('.amount');
        if (delAmount) delAmount.textContent = compareAtText;
      } else {
        del.style.display = 'none';
      }
    });
  };

  const updateAddToCartPrice = (sectionId, variant) => {
    if (!sectionId) return;
    ensureAtcPriceElements(sectionId);

    const resolvedVariant = variant || getVariantFromSection(sectionId);
    if (resolvedVariant) {
      window.theme = window.theme || {};
      window.theme.currentVariantBySection = window.theme.currentVariantBySection || {};
      window.theme.currentVariantBySection[sectionId] = resolvedVariant;
    }

    const giftChoice = document.querySelector(`[data-gift-bag-choice="yes"][data-section-id="${sectionId}"]`);
    const giftExtra = giftChoice && giftChoice.checked
      ? parseInt(giftChoice.dataset.giftBagPriceCents || '0', 10)
      : 0;
    const engravingPanel = document.querySelector(`[data-engraving-panel][data-section-id="${sectionId}"]`);
    const engravingChoice = engravingPanel?.querySelector('[data-engraving-choice="yes"]');
    const engravingExtra = engravingChoice && engravingChoice.checked ? 1000 : 0;
    const birthstoneExtra = parseInt(document.documentElement.dataset.birthstonePriceCents || '0', 10) || 0;

    const hasPrice = resolvedVariant && typeof resolvedVariant.price !== 'undefined';
    const adjustedPrice = hasPrice ? resolvedVariant.price + giftExtra + birthstoneExtra + engravingExtra : null;
    const compareAt = hasPrice ? resolvedVariant.compare_at_price : null;
    const adjustedCompareAt = compareAt ? compareAt + giftExtra + birthstoneExtra + engravingExtra : null;

    let priceText = hasPrice ? formatMoneySafe(adjustedPrice) : '';
    const compareAtText = adjustedCompareAt ? formatMoneySafe(adjustedCompareAt) : '';

    if (!priceText) {
      const priceWrap = document.getElementById(`price-${sectionId}`);
      const amountEl = priceWrap?.querySelector('ins .amount');
      priceText = amountEl ? amountEl.textContent.trim() : '';
    }

    if (priceText) {
      const showCompareAt = adjustedCompareAt && adjustedCompareAt > adjustedPrice;
      updatePriceBlocks(sectionId, priceText, compareAtText, showCompareAt);
    }

    const priceEls = Array.from(document.querySelectorAll(`[data-add-to-cart-price][data-section-id="${sectionId}"]`));
    const separatorEls = Array.from(document.querySelectorAll(`[data-add-to-cart-separator][data-section-id="${sectionId}"]`));
    const showPrice = !!(resolvedVariant && resolvedVariant.available && priceText);

    priceEls.forEach((priceEl) => {
      const button = priceEl.closest('button');
      const labelEl = button?.querySelector('.single-add-to-cart-button--text') || button?.querySelector('span');
      const labelText = labelEl ? labelEl.textContent.trim() : '';
      const shouldHide =
        labelText === 'AJOUTER LA PERSONNALISATION' ||
        labelText === 'CHARGEZ D\u2019ABORD LE FICHIER';
      priceEl.hidden = shouldHide || !showPrice;
      if (!priceEl.hidden) {
        priceEl.textContent = priceText;
      }
    });

    separatorEls.forEach((separatorEl) => {
      const button = separatorEl.closest('button');
      const labelEl = button?.querySelector('.single-add-to-cart-button--text') || button?.querySelector('span');
      const labelText = labelEl ? labelEl.textContent.trim() : '';
      const shouldHide =
        labelText === 'AJOUTER LA PERSONNALISATION' ||
        labelText === 'CHARGEZ D\u2019ABORD LE FICHIER';
      separatorEl.hidden = shouldHide || !showPrice;
    });
  };

  window.updateAddToCartPrice = updateAddToCartPrice;

  const hookProductPriceRender = () => {
    if (window.__engravingPriceHooked) return;

    const tryHook = () => {
      const VariantSelects = window.customElements?.get('variant-selects');
      if (!VariantSelects || !VariantSelects.prototype?.renderProductInfo) return false;
      if (VariantSelects.prototype.__engravingPatched) {
        window.__engravingPriceHooked = true;
        return true;
      }

      const original = VariantSelects.prototype.renderProductInfo;
      VariantSelects.prototype.renderProductInfo = function patchedRenderProductInfo() {
        original.apply(this, arguments);
        const sectionId = this.dataset.section;
        if (!sectionId) return;
        const targets = [
          document.getElementById(`price-${sectionId}`),
          document.getElementById(`price-${sectionId}--sticky`)
        ].filter(Boolean);
        if (!targets.length) return;

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          observer.disconnect();
          updateAddToCartPrice(sectionId, this.currentVariant || getVariantFromSection(sectionId));
        };
        const observer = new MutationObserver(() => finish());
        targets.forEach((target) => {
          observer.observe(target, { childList: true, subtree: true, characterData: true });
        });
        window.setTimeout(finish, 1500);
      };
      VariantSelects.prototype.__engravingPatched = true;
      window.__engravingPriceHooked = true;
      return true;
    };

    if (tryHook()) return;
    const interval = window.setInterval(() => {
      if (tryHook()) window.clearInterval(interval);
    }, 200);
    window.setTimeout(() => window.clearInterval(interval), 5000);
  };

  const initAddToCartPricing = () => {
    const schedulePriceUpdate = (() => {
      const pendingTimers = new Map();
      const delays = [300];
      return (sectionId) => {
        if (!sectionId) return;
        const existing = pendingTimers.get(sectionId);
        if (existing) {
          existing.forEach((timerId) => window.clearTimeout(timerId));
        }
        const timers = delays.map((delay) =>
          window.setTimeout(() => {
            updateAddToCartPrice(sectionId, window.theme?.currentVariantBySection?.[sectionId]);
          }, delay)
        );
        pendingTimers.set(sectionId, timers);
      };
    })();

    document.querySelectorAll('product-form[data-section]').forEach((form) => {
      const sectionId = form.dataset.section;
      updateAddToCartPrice(sectionId, getVariantFromSection(sectionId));
    });

    document.addEventListener('product:variant-change', (event) => {
      const sectionId = event.detail?.sectionId;
      if (!sectionId) return;
      updateAddToCartPrice(sectionId, event.detail?.variant);
      schedulePriceUpdate(sectionId);
    });

    document.addEventListener('change', (event) => {
      const variantSelects = event.target.closest('variant-selects[data-custom-variant-picker]');
      if (variantSelects) {
        const sectionId = variantSelects.dataset.section;
        updateAddToCartPrice(sectionId, getVariantFromSection(sectionId));
        schedulePriceUpdate(sectionId);
        return;
      }
      if (!event.target.matches('[data-gift-bag-choice]')) return;
      const sectionId = event.target.dataset.sectionId;
      updateAddToCartPrice(sectionId, window.theme?.currentVariantBySection?.[sectionId]);
    });
  };

  const getCart = async () => {
    const response = await fetch(getCartUrl(), { credentials: 'same-origin' });
    if (!response.ok) return null;
    return response.json();
  };

  const updateLineItem = async (key, quantity) => {
    const body = JSON.stringify({
      id: key,
      quantity,
      sections: [],
      sections_url: window.location.pathname
    });
    const response = await fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body
    });
    if (!response.ok) return null;
    return response.json();
  };

  const addLineItemWithProperties = async (variantId, quantity, properties) => {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    if (properties) {
      Object.entries(properties).forEach(([key, value]) => {
        if (typeof value === 'undefined' || value === null) return;
        formData.append(`properties[${key}]`, value);
      });
    }
    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });
    if (!response.ok) return null;
    return response.json();
  };

  const addLineItem = async (variantId, quantity) => {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });
    if (!response.ok) return null;
    return response.json();
  };

  const getAddonPrices = (cart) => {
    const prices = {};
    if (!cart || !Array.isArray(cart.items)) return prices;
    cart.items.forEach((item) => {
      const id = String(item.id);
      if (id === ADDON_VARIANTS.empreinte1) prices.empreinte1 = item.price;
      if (id === ADDON_VARIANTS.empreinte2) prices.empreinte2 = item.price;
      if (id === ADDON_VARIANTS.texte) prices.texte = item.price;
      if (id === ADDON_VARIANTS.ecrit) prices.ecrit = item.price;
      if (id === ADDON_VARIANTS.gift) prices.gift = item.price;
    });
    return prices;
  };

  const getGiftValue = (properties) => {
    if (!properties) return '';
    const entry = Object.entries(properties).find(([key]) => normalize(key) === 'sac cadeau');
    return entry ? String(entry[1] || '').trim() : '';
  };

  const buildPropertyElements = (item, addonPrices) => {
    const properties = item.properties || {};
    const propertyElements = [];
    const fileElements = [];
    let giftLine = null;
    let giftNoteValue = '';
    let versoValue = '';
    let typeValue = '';
    let typePriceText = '';
    let typePriceCents = 0;
    let empreinteValue = '';
    let empreintePriceText = '';
    let empreintePriceCents = 0;
    let hasCoeurLayout = false;

    Object.entries(properties).forEach(([key, rawValue]) => {
      const value = String(rawValue || '').trim();
      if (!value || String(key).startsWith('_')) return;

      const keyNormalized = normalize(key);

      if (keyNormalized === 'sac cadeau') {
        if (normalize(value).includes('non')) return;
        giftLine = { label: key, value: value };
        return;
      }

      if (keyNormalized === 'offert avec amour par') {
        giftNoteValue = value;
        return;
      }

      if (keyNormalized === "kit d'empreintes" || keyNormalized === 'kit d\u2019empreintes') {
        if (normalize(value) === 'oui') return;
      }

      if (keyNormalized.includes('style de la gravure')) {
        if (normalize(value).includes('coeur')) {
          hasCoeurLayout = true;
        }
        return;
      }

      if (keyNormalized === 'gravure') {
        if (normalize(value) === 'oui') {
          versoValue = 'OUI';
        }
        return;
      }

      if (keyNormalized.includes('type de gravure')) {
        if (value === 'Texte Personnalis\u00e9') {
          typeValue = 'Texte';
          if (addonPrices.texte) {
            typePriceText = formatMoneySafe(addonPrices.texte);
            typePriceCents = addonPrices.texte;
          }
        } else if (value === '\u00c9crit' || value === 'Ecrit') {
          typeValue = '\u00c9crit';
          if (addonPrices.ecrit) {
            typePriceText = formatMoneySafe(addonPrices.ecrit);
            typePriceCents = addonPrices.ecrit;
          }
        } else if (value === 'Empreinte') {
          typeValue = 'Empreinte';
        }
        return;
      }

      if (keyNormalized === 'prenom') {
        key = 'Ligne 1';
      } else if (keyNormalized === 'date') {
        key = 'Ligne 2';
      }

      if (keyNormalized.includes("nombre d")) {
        let label = value;
        if (normalize(value).includes('1')) {
          label = '1 Empreinte';
          if (addonPrices.empreinte1) {
            empreintePriceText = formatMoneySafe(addonPrices.empreinte1);
            empreintePriceCents = addonPrices.empreinte1;
          }
        } else if (normalize(value).includes('2')) {
          label = '2 Empreintes';
          if (addonPrices.empreinte2) {
            empreintePriceText = formatMoneySafe(addonPrices.empreinte2);
            empreintePriceCents = addonPrices.empreinte2;
          }
        }
        empreinteValue = label;
        return;
      }

      const isUpload = value.includes('/uploads/');
      const element = { label: key, value, isUpload };

      if (isUpload) {
        fileElements.push(element);
        return;
      }

      if (hasCoeurLayout && keyNormalized.includes('police')) {
        propertyElements.push({ label: 'Ligne 3', value: 'Coeur', isUpload: false });
        hasCoeurLayout = false;
      }

      propertyElements.push(element);
    });

    const lines = [];
    if (versoValue) {
      if (typeValue === 'Empreinte' && empreinteValue) {
        const linePriceCents = empreintePriceCents ? empreintePriceCents * item.quantity : 0;
        lines.push({ label: 'VERSO', value: `${versoValue}, ${empreinteValue}`, priceCents: linePriceCents });
      } else if (typeValue) {
        const linePriceCents = typePriceCents ? typePriceCents * item.quantity : 0;
        lines.push({ label: 'VERSO', value: `${versoValue}, ${typeValue}`, priceCents: linePriceCents });
      } else {
        lines.push({ label: 'VERSO', value: versoValue });
      }
    }

    lines.push(...propertyElements);
    lines.push(...fileElements);

    if (giftNoteValue) {
      lines.push({ label: 'Offert avec amour par', value: giftNoteValue });
    }

    return lines;
  };

  const createPropertyElement = ({ label, value }) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'product-card-small--options';

    const span = document.createElement('span');
    span.textContent = `${label}: `;
    wrapper.appendChild(span);

    if (value && value.includes('/uploads/')) {
      const link = document.createElement('a');
      link.href = value;
      link.className = 'link';
      link.target = '_blank';
      const fileName = value.split('/').pop();
      link.textContent = fileName || value;
      wrapper.appendChild(link);
    } else {
      wrapper.appendChild(document.createTextNode(value));
    }

    wrapper.appendChild(document.createElement('br'));
    return wrapper;
  };

  const updateAddonPriceLines = (itemEl, lines) => {
    if (!itemEl) return;
    const priceCol = itemEl.querySelector('.product-card-small--price');
    const infoCol = itemEl.querySelector('.product-card-small--info');
    if (!priceCol || !infoCol) return;
    const existing = priceCol.querySelector('.product-card-small--price-addons');
    if (existing) existing.remove();
    const addonLines = lines.filter((line) => typeof line.priceCents === 'number' && line.priceCents > 0);
    if (!addonLines.length) return;
    const optionEls = Array.from(infoCol.querySelectorAll('.product-card-small--options'));
    const priceRect = priceCol.getBoundingClientRect();
    const container = document.createElement('div');
    container.className = 'product-card-small--price-addons';

    optionEls.forEach((optionEl) => {
      const inline = optionEl.querySelector('.product-card-small--option-addon-price');
      if (inline) inline.remove();
    });

    addonLines.forEach((line) => {
      const match = optionEls.find((optionEl) => {
        const span = optionEl.querySelector('span');
        if (!span) return false;
        const label = span.textContent.replace(':', '').trim();
        return normalize(label) === normalize(line.label || '');
      });
      if (!match) return;
      const optionRect = match.getBoundingClientRect();
      const row = document.createElement('div');
      row.className = 'product-card-small--price-addon';
      row.textContent = formatMoneySafe(line.priceCents);
      row.style.top = `${optionRect.top - priceRect.top - 5}px`;
      container.appendChild(row);

      const inline = document.createElement('div');
      inline.className = 'product-card-small--option-addon-price';
      inline.textContent = formatMoneySafe(line.priceCents);
      match.appendChild(inline);
    });

    if (!container.children.length) return;
    priceCol.appendChild(container);
  };

  const updateItemProperties = (itemEl, item, addonPrices) => {
    if (!itemEl) return;
    const infoContainer = itemEl.querySelector('.product-card-small--options')?.parentElement || itemEl;
    const propertyKeys = Object.keys(item.properties || {});
    const extraLabels = ['verso', 'sac cadeau', 'ligne 1', 'ligne 2', 'ligne 3'];
    const options = Array.from(infoContainer.querySelectorAll('.product-card-small--options'));

    options.forEach((option) => {
      const span = option.querySelector('span');
      if (!span) return;
      const label = span.textContent.replace(':', '').trim();
      const normalizedLabel = normalize(label);
      if (extraLabels.includes(normalizedLabel)) {
        option.remove();
      }
    });

    propertyKeys.forEach((key) => {
      const keyNormalized = normalize(key);
      options.forEach((option) => {
        const span = option.querySelector('span');
        if (!span) return;
        const label = span.textContent.replace(':', '').trim();
        if (normalize(label) === keyNormalized) {
          option.remove();
        }
      });
    });

    const lines = buildPropertyElements(item, addonPrices);
    if (!lines.length) return;

    const optionsAfter = infoContainer.querySelectorAll('.product-card-small--options');
    let insertAfter = optionsAfter.length ? optionsAfter[optionsAfter.length - 1] : null;
    lines.forEach((line) => {
      const element = createPropertyElement(line);
      if (insertAfter) {
        insertAfter.insertAdjacentElement('afterend', element);
        insertAfter = element;
      } else {
        infoContainer.appendChild(element);
        insertAfter = element;
      }
    });
    updateAddonPriceLines(itemEl, lines);
  };

  const hideAddonItems = (itemEl) => {
    if (!itemEl) return;
    itemEl.classList.add('engraving-addon-hidden');
    itemEl.style.display = 'none';
    itemEl.setAttribute('aria-hidden', 'true');
  };

  const updateKitPriceDisplay = (itemEl) => {
    if (!itemEl) return;
    const priceWraps = itemEl.querySelectorAll('.price');
    priceWraps.forEach((priceWrap) => {
      const del = priceWrap.querySelector('del');
      if (del) del.style.display = 'none';
      const ins = priceWrap.querySelector('ins');
      if (ins) ins.style.display = '';
      const amountEls = priceWrap.querySelectorAll('.amount');
      amountEls.forEach((amountEl) => {
        amountEl.textContent = 'Offert';
      });
      const totalLineItem = priceWrap.querySelector('.pn-total-line-item');
      if (totalLineItem) totalLineItem.textContent = 'Offert';
      const unitPrice = priceWrap.querySelector('.unit-price');
      if (unitPrice) unitPrice.style.display = 'none';
    });
  };

  const lockItemQuantity = (itemEl) => {
    if (!itemEl) return;
    const qtySelectors = itemEl.querySelectorAll('quantity-selector');
    if (!qtySelectors.length) return;
    qtySelectors.forEach((qty) => {
      qty.classList.add('qty-locked');
      const input = qty.querySelector('input[type="number"]');
      if (input) {
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('aria-readonly', 'true');
      }
      const minus = qty.querySelector('.minus');
      const plus = qty.querySelector('.plus');
      if (minus) {
        minus.setAttribute('disabled', 'disabled');
        minus.style.display = 'none';
      }
      if (plus) {
        plus.setAttribute('disabled', 'disabled');
        plus.style.display = 'none';
      }
    });
  };

  const applyCartDisplay = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    const addonPrices = getAddonPrices(cart);

    cart.items.forEach((item, index) => {
      const lineIndex = index + 1;
      const itemId = String(item.id);
      const isAddon = DISPLAY_HIDDEN_ADDON_IDS.has(itemId);

      const drawerItem = document.getElementById(`CartDrawerItem-${lineIndex}`);
      const cartItem = document.getElementById(`CartItem-${lineIndex}`);

      if (isAddon) {
        hideAddonItems(drawerItem);
        hideAddonItems(cartItem);
        return;
      }
      const isCustomKitAddon = item?.properties && (item.properties[CUSTOM_KIT_ADDON_KEY] || item.properties['_kit_addon']);

      if (itemId === ADDON_VARIANTS.kit || isCustomKitAddon) {
        lockItemQuantity(drawerItem);
        updateKitPriceDisplay(drawerItem);
        lockItemQuantity(cartItem);
        updateKitPriceDisplay(cartItem);
      }

      updateItemProperties(drawerItem, item, addonPrices);
      updateItemProperties(cartItem, item, addonPrices);
    });
  };

  const syncAddonQuantities = (() => {
    let isSyncing = false;
    let pending = false;

    const schedule = async (cartOverride) => {
      if (isSyncing) {
        pending = true;
        return;
      }
      isSyncing = true;
      try {
        const cart = cartOverride || await getCart();
        if (!cart || !Array.isArray(cart.items)) return;

        const desired = {
          kit: 0,
          empreinte1: 0,
          empreinte2: 0,
          texte: 0,
          ecrit: 0
        };

        const existing = {};
        const desiredCustom = {};
        const existingCustom = {};

        cart.items.forEach((item) => {
          const id = String(item.id);
          const props = item.properties || {};
          const customKitId = props[CUSTOM_KIT_PROPERTY_KEY];
          const isCustomKitAddon = !!(props && (props[CUSTOM_KIT_ADDON_KEY] || props['_kit_addon']));
          if (isCustomKitAddon) {
            const variantId = String(customKitId || id);
            existingCustom[variantId] = { key: item.key, quantity: item.quantity };
            return;
          }
          if (ADDON_IDS.has(id)) {
            existing[id] = { key: item.key, quantity: item.quantity };
            return;
          }

          const kitValue = Object.entries(props).find(([key]) => {
            const keyNormalized = normalize(key);
            return keyNormalized.includes('kit d') && keyNormalized.includes('empreinte');
          })?.[1];
          if (kitValue && normalize(kitValue).includes('oui')) {
            const customId = customKitId && String(customKitId);
            if (customId && customId != String(ADDON_VARIANTS.kit)) {
              desiredCustom[customId] = (desiredCustom[customId] || 0) + item.quantity;
            } else {
              desired.kit += item.quantity;
            }
          }

          const versoValue = props['Gravure'] || props['gravure'];
          if (!versoValue || !normalize(versoValue).includes('oui')) return;

          const typeValue = props['Type de Gravure'] || props['Type de gravure'] || props['type de gravure'];
          if (!typeValue) return;
          const typeNormalized = normalize(typeValue);
          if (typeNormalized.includes('empreinte')) {
            const countValue = props["Nombre d'empreinte"] || props['Nombre d\u2019empreinte'] || props['Nombre d\u2019empreintes'];
            const countNormalized = normalize(countValue || '');
            if (countNormalized.includes('2')) {
              desired.empreinte2 += item.quantity;
            } else {
              desired.empreinte1 += item.quantity;
            }
          } else if (typeNormalized.includes('texte')) {
            desired.texte += item.quantity;
          } else if (typeNormalized.includes('ecrit')) {
            desired.ecrit += item.quantity;
          }
        });

        // sync custom kit items found without _kit_addon flag
        Object.keys(desiredCustom).forEach((variantId) => {
          if (existingCustom[variantId]) return;
          const found = cart.items.find((item) => String(item.id) === String(variantId));
          if (found) {
            existingCustom[variantId] = { key: found.key, quantity: found.quantity };
          }
        });

        const updates = [
          { key: ADDON_VARIANTS.kit, desired: desired.kit },
          { key: ADDON_VARIANTS.empreinte1, desired: desired.empreinte1 },
          { key: ADDON_VARIANTS.empreinte2, desired: desired.empreinte2 },
          { key: ADDON_VARIANTS.texte, desired: desired.texte },
          { key: ADDON_VARIANTS.ecrit, desired: desired.ecrit }
        ];

        let didUpdate = false;
        for (const update of updates) {
          const existingLine = existing[update.key];
          if (existingLine) {
            if (update.desired !== existingLine.quantity) {
              await updateLineItem(existingLine.key, update.desired);
              didUpdate = true;
            }
          } else if (update.desired > 0) {
            await addLineItem(update.key, update.desired);
            didUpdate = true;
          }
        }        // custom kit add-ons (per main product _kit_variant_id)
        const customVariantIds = new Set([
          ...Object.keys(desiredCustom),
          ...Object.keys(existingCustom)
        ]);
        for (const variantId of customVariantIds) {
          const desiredQty = desiredCustom[variantId] || 0;
          const existingLine = existingCustom[variantId];
          if (!desiredQty && existingLine) {
            await updateLineItem(existingLine.key, 0);
            didUpdate = true;
            continue;
          }
          if (desiredQty && existingLine) {
            if (desiredQty !== existingLine.quantity) {
              await updateLineItem(existingLine.key, desiredQty);
              didUpdate = true;
            }
            continue;
          }
          if (desiredQty && !existingLine) {
            await addLineItemWithProperties(variantId, desiredQty, { _kit_addon: 'true', _kit_variant_id: variantId });
            didUpdate = true;
          }
        }

        if (didUpdate) {
          document.documentElement.dispatchEvent(new CustomEvent(CART_REFRESH_EVENT, { bubbles: true }));
        }
      } finally {
        isSyncing = false;
        if (pending) {
          pending = false;
          schedule();
        }
      }
    };

    return schedule;
  })();

  const handleCartRefresh = (() => {
    let timer = null;

    return (event) => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(async () => {
        const cartFromEvent = event?.detail?.cart;
        const cart = cartFromEvent && Array.isArray(cartFromEvent.items) ? cartFromEvent : await getCart();
        if (!cart || !Array.isArray(cart.items)) return;
        applyCartDisplay(cart);
        syncAddonQuantities(cart);
        cleanupSubtotalLine();
        updateCheckoutButtonPrice(cart);
        ensurePaymentIcons();
        moveFreeShippingBar();
        ensureCartDrawerExtras();
      }, 50);
    };
  })();

  const cleanupSubtotalLine = () => {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    const blocks = Array.from(drawer.querySelectorAll('.cart-drawer--discount'));
    blocks.forEach((block) => {
      const policy = block.querySelector('.cart-policy-text');
      const price = block.querySelector('.price');
      if (!policy || !price) return;
      block.classList.add('subtotal-hidden');
      price.remove();
      const label = block.querySelector('.cart-drawer--discount-label');
      if (!label) return;
      Array.from(label.childNodes).forEach((node) => {
        if (node === policy) return;
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) return;
        node.remove();
      });
    });
  };

  const updateCheckoutButtonPrice = (cart) => {
    if (!cart) return;
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    const button = drawer.querySelector('button.checkout-button');
    if (!button) return;

    let label = button.querySelector('.checkout-button__label');
    let separator = button.querySelector('.checkout-button__separator');
    let price = button.querySelector('.checkout-button__price');

    if (!label) {
      const fallback = button.textContent.trim();
      button.textContent = '';
      label = document.createElement('span');
      label.className = 'checkout-button__label';
      label.textContent = fallback || '';
      button.appendChild(label);
    }

    if (!separator) {
      separator = document.createElement('span');
      separator.className = 'checkout-button__separator';
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = '|';
      button.appendChild(separator);
    }

    if (!price) {
      price = document.createElement('span');
      price.className = 'checkout-button__price';
      button.appendChild(price);
    }

    const priceText = typeof cart.total_price === 'number' ? formatMoneySafe(cart.total_price) : '';
    if (priceText) {
      price.textContent = priceText;
    }
  };

  let paymentIconsTemplate = '';

  const getPaymentIconsTemplate = () => {
    if (paymentIconsTemplate) return paymentIconsTemplate;
    const candidates = Array.from(document.querySelectorAll('.payment-icons'));
    const source = candidates.find((el) => !el.closest('#Cart-Drawer')) || candidates[0];
    if (source) {
      paymentIconsTemplate = source.outerHTML;
    }
    return paymentIconsTemplate;
  };

  const ensurePaymentIcons = () => {
    const template = getPaymentIconsTemplate();
    if (!template) return;
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    if (drawer.querySelector('.payment-icons')) return;
    const checkoutForm = drawer.querySelector('.cart-drawer--buttons form[action*="/cart"]');
    if (!checkoutForm) return;
    checkoutForm.insertAdjacentHTML('afterend', template);
  };

  const moveFreeShippingBar = () => {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    const freeShipping = drawer.querySelector('free-shipping.free-shipping');
    if (!freeShipping) return;
    const checkoutForm = drawer.querySelector('.cart-drawer--buttons form[action*="/cart"]');
    if (!checkoutForm) return;
    checkoutForm.insertAdjacentElement('beforebegin', freeShipping);
  };

  const ensureCartDrawerExtras = () => {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    const extras = drawer.querySelector('.cart-drawer--extras');
    if (!extras) return;
    const freeShipping = drawer.querySelector('free-shipping.free-shipping');
    if (freeShipping && freeShipping.parentElement !== extras) {
      extras.insertAdjacentElement('afterbegin', freeShipping);
    }
    const paymentIcons = drawer.querySelector('.payment-icons');
    if (paymentIcons && paymentIcons.parentElement !== extras) {
      const checkoutForm = drawer.querySelector('.cart-drawer--buttons form[action*="/cart"]');
      if (checkoutForm) {
        checkoutForm.insertAdjacentElement('afterend', paymentIcons);
      }
    }
  };


  const interceptCartLinks = () => {
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.pathname !== '/cart' && url.pathname !== '/cart/') return;

      event.preventDefault();
      document.documentElement.dispatchEvent(new CustomEvent(CART_REFRESH_EVENT, { bubbles: true }));
      document.getElementById('Cart-Drawer')?.open();
    });
  };

  const hideHiddenProductAddons = (() => {
    const cache = new Map();
    let pending = null;

    const getHandleFromElement = (element) => {
      if (!element) return '';
      if (element.dataset?.productHandle) return element.dataset.productHandle;
      const link = element.querySelector('a[href*="/products/"]') || element.closest('a[href*="/products/"]');
      if (!link) return '';
      try {
        const url = new URL(link.href, window.location.origin);
        const parts = url.pathname.split('/').filter(Boolean);
        const idx = parts.indexOf('products');
        return idx >= 0 ? parts[idx + 1] || '' : '';
      } catch (error) {
        return '';
      }
    };

    const hideCard = (element) => {
      if (!element) return;
      const cartContainer = element.closest('#Cart-Drawer, #Cart, .cart-drawer, .cart, [data-cart-drawer]');
      if (cartContainer) return;
      const wrapper = element.closest(
        '.products--column, .grid__item, .search-results__item, .search-results__product, .predictive-search__item, .predictive-search__result, .carousel__slide'
      );
      if (wrapper) {
        wrapper.classList.add('engraving-addon-hidden');
        return;
      }
      const card = element.closest('product-card, .product-card, .product-card-small');
      if (card) {
        card.classList.add('engraving-addon-hidden');
        return;
      }
      element.classList.add('engraving-addon-hidden');
    };

    const getElementsByHandle = (handle) => {
      if (!handle) return [];
      const handleSelector = `[data-product-handle="${handle}"]`;
      const linkSelector = `a[href*="/products/${handle}"]`;
      return Array.from(document.querySelectorAll(`${handleSelector}, ${linkSelector}`));
    };

    const run = async () => {
      const candidates = Array.from(
        document.querySelectorAll(
          '[data-product-handle], .product-card, .product-card--quickview, .product-card-small, .predictive-search__item, .predictive-search__result, .search-results__item, .search-results__product, .grid__item'
        )
      );
      const handles = new Set();

      candidates.forEach((element) => {
        const handle = getHandleFromElement(element);
        if (handle) handles.add(handle);
      });

      for (const handle of handles) {
        if (cache.has(handle)) {
          if (cache.get(handle)) {
            getElementsByHandle(handle).forEach(hideCard);
          }
          continue;
        }

        try {
          const response = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
          if (!response.ok) {
            cache.set(handle, false);
            continue;
          }
          const product = await response.json();
          const isHidden = Array.isArray(product.tags) && product.tags.includes('hidden-product-addon');
          cache.set(handle, isHidden);
          if (isHidden) {
            getElementsByHandle(handle).forEach(hideCard);
          }
        } catch (error) {
          cache.set(handle, false);
        }
      }
    };

    return () => {
      if (pending) return;
      pending = window.setTimeout(async () => {
        pending = null;
        await run();
      }, 200);
    };
  })();

  const observeProductGrids = () => {
    const observer = new MutationObserver(() => {
      hideHiddenProductAddons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const observeCartContainers = () => {
    const targets = [
      document.getElementById('Cart-Drawer'),
      document.getElementById('Cart')
    ].filter(Boolean);
    if (!targets.length) return;
    const observer = new MutationObserver(() => {
      handleCartRefresh();
    });
    targets.forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });
  };

  const bindCartToggleRefresh = () => {
    const toggle = document.getElementById('cart-drawer-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      setTimeout(() => handleCartRefresh(), 50);
    });
  };


  const init = () => {
    applyMediaGroups();
    hookProductPriceRender();
    initAddToCartPricing();
    handleCartRefresh();
    cleanupSubtotalLine();
    ensurePaymentIcons();
    moveFreeShippingBar();
    ensureCartDrawerExtras();
    interceptCartLinks();
    hideHiddenProductAddons();
    observeProductGrids();
    observeCartContainers();
    bindCartToggleRefresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener(CART_REFRESH_EVENT, handleCartRefresh);
  document.addEventListener('line-item:change:end', handleCartRefresh);
})();
